// Forex sessions in local market time — Intl handles each city's DST.
export const SESSIONS = [
  { id: "sydney", tz: "Australia/Sydney", open: 7 * 60, close: 16 * 60 },
  { id: "tokyo", tz: "Asia/Tokyo", open: 9 * 60, close: 18 * 60 },
  { id: "london", tz: "Europe/London", open: 8 * 60, close: 17 * 60 },
  { id: "newyork", tz: "America/New_York", open: 8 * 60, close: 17 * 60 },
];

const DOW = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
const fmtCache = {};

function wall(date, tz) {
  fmtCache[tz] ||= new Intl.DateTimeFormat("en-US", { timeZone: tz, weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
  const p = Object.fromEntries(fmtCache[tz].formatToParts(date).map((x) => [x.type, x.value]));
  return { dow: DOW[p.weekday], minutes: (parseInt(p.hour, 10) % 24) * 60 + parseInt(p.minute, 10) };
}

const isWeekday = (d) => d >= 1 && d <= 5;

export function isOpen(s, now = new Date()) {
  const w = wall(now, s.tz);
  return isWeekday(w.dow) && w.minutes >= s.open && w.minutes < s.close;
}

// Minutes until the session closes (if open) or next opens (if closed).
export function minutesToChange(s, now = new Date()) {
  const w = wall(now, s.tz);
  if (isOpen(s, now)) return s.close - w.minutes;
  for (let d = 0; d <= 7; d++) {
    if (!isWeekday((w.dow + d) % 7)) continue;
    const delta = d * 1440 + s.open - w.minutes;
    if (delta > 0) return delta;
  }
  return null;
}

export function forexWeekendClosed(now = new Date()) {
  const w = wall(now, "America/New_York");
  return w.dow === 6 || (w.dow === 5 && w.minutes >= 17 * 60) || (w.dow === 0 && w.minutes < 17 * 60);
}

// "overlap" | "newyork" | "london" | "tokyo" | "sydney" | "off"
export function primarySession(date) {
  const open = SESSIONS.filter((s) => isOpen(s, date)).map((s) => s.id);
  if (open.includes("london") && open.includes("newyork")) return "overlap";
  return ["newyork", "london", "tokyo", "sydney"].find((id) => open.includes(id)) || "off";
}

export function fmtDuration(mins) {
  if (mins == null) return "—";
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  return d ? `${d}d ${h}h` : h ? `${h}h ${m}m` : `${m}m`;
}
